import React from 'react';
import styled from 'styled-components';
// import { about_img } from '../../images/index';
import Pdf from '../../config/resume.pdf';
import Image from '../about-image';
import SEO from '../seo';
const AboutContainer = styled.div`
  text-align: left;
`;
const AboutContent = styled.p`
  font-size: 16px;
  margin: 1rem auto auto 1rem;
  line-height: 1.4;
`;
const ImageWrapper = styled.div`
  text-align: center;
  margin: 30px auto;
  width: 150px;
  filter: grayscale(1);
  transition: filter 0.2s, transform 0.2s;
  &:hover {
    transform: rotate(5deg) scale(1.05);
    filter: grayscale(0);
  }
`;
const Heading = styled.h2`
  color: var(--color-primary);
`;

const StyledLink = styled.a`
  /* border-bottom: 1px solid var(--color-primary); */
  text-decoration-line: underline;
  /* text-decoration-style: wavy; */
  text-decoration-color: var(--color-primary);
`;
const ResumeBtn = styled.a`
  background: transparent;
  width: 25%;
  border: 1.5px solid var(--color-primary);
  margin: 1rem auto;
  display: flex;
  cursor: pointer;
  color: var(--color-text);
  justify-content: center;
  padding: 0.8rem 1.8rem;
  &:hover {
    background: var(--color-primary);
    color: var(--color-text);
  }
`;

const About = () => {
  const onResumeClick = () => {
    window.open(Pdf);
  };
  return (
    <AboutContainer>
      <SEO title="About" />
      <Heading>Hi,</Heading>
      <AboutContent>
        I am Subhendu Maji. I make awesome things for awesome people.
        <br />
        <br /> I am a software engineer residing in Bangalore, India. I have
        worked with and for names such as{' '}
        <StyledLink target="_blank" href="https://federateconsulting.com/">
          Federate Consulting
        </StyledLink>
        ,{' '}
        <StyledLink target="_blank" href="https://idreamcareer.com/">
          iDreamCareer.com
        </StyledLink>{' '}
        and{' '}
        <StyledLink target="_blank" href="https://www.protechengineering.in/">
          Protech Engineering
        </StyledLink>
        . I'm comfortable with a variety of tools. Typically I'll be digging in
        with ReactJS.
      </AboutContent>
      {/* <AboutImg src={about_img} alt={'subhendu maji'} /> */}
      <ImageWrapper>
        <Image />
      </ImageWrapper>
      <AboutContent>
        When I am not coding I am painting a masterpiece. <br />
        Got any million-dollar idea? Let’s meet! Coffee is on me.
        <br />
        <br /> P.S. I prefer tabs over spaces.
      </AboutContent>
      <ResumeBtn onClick={onResumeClick}>Resume</ResumeBtn>
    </AboutContainer>
  );
};

export default About;
